/**
 * @generated SignedSource<<1d1f7645bac8ef409b8ed6ca9fba8b7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueSummaryTeamItemUnresolvedCount_team$data = {
  readonly unresolvedIssueCount: number;
  readonly " $fragmentType": "WidgetIssueSummaryTeamItemUnresolvedCount_team";
};
export type WidgetIssueSummaryTeamItemUnresolvedCount_team$key = {
  readonly " $data"?: WidgetIssueSummaryTeamItemUnresolvedCount_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueSummaryTeamItemUnresolvedCount_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueSummaryTeamItemUnresolvedCount_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unresolvedIssueCount",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "78bf11fddf1e12f7ae3f32794d43f010";

export default node;
